import { useState } from "react";
import { cn } from "../../lib/utils";

export type MapPreviewKind = "aerial" | "topo";

interface MapPreviewImageProps {
  lat: number;
  lng: number;
  kind?: MapPreviewKind;
  className?: string;
  "data-testid"?: string;
}

// Inline static map preview backed by GET /api/map/static. Shows a muted
// placeholder background until the image has finished loading, so slow or
// cold-cache renders don't leave a blank box.
export function MapPreviewImage({
  lat,
  lng,
  kind = "aerial",
  className,
  "data-testid": testId,
}: MapPreviewImageProps): React.ReactElement {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={cn("relative overflow-hidden rounded-md border bg-muted", className)}>
      <img
        src={`/api/map/static?lat=${lat}&lng=${lng}&kind=${kind}`}
        loading="lazy"
        alt="Aerial view of the property"
        className={cn(
          "h-full w-full object-cover transition-opacity duration-200",
          loaded ? "opacity-100" : "opacity-0",
        )}
        onLoad={() => setLoaded(true)}
        data-testid={testId ?? "map-preview"}
      />
    </div>
  );
}
